// Langue de l'interface (français / anglais) — pour TOUS les tenants.
//
// Ordre de résolution :
//   1. le choix fait dans « Mon profil » (enregistré sur le serveur, champ
//      `langue` de l'utilisateur, recopié localement pour le démarrage) ;
//   2. sinon la langue de l'appareil (navigateur / téléphone) ;
//   3. sinon le français.
//
// Un texte sans traduction anglaise s'affiche en français (fallbackLng) :
// aucun écran ne casse pendant la traduction progressive des modules.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';

export const LANGUES = ['fr', 'en'];
const CLE_PREFERENCE = 'pfm_langue';

export function langueAppareil() {
  try {
    const liste = (navigator.languages && navigator.languages.length)
      ? navigator.languages : [navigator.language];
    for (const l of liste) {
      const code = String(l || '').slice(0, 2).toLowerCase();
      if (LANGUES.includes(code)) return code;
    }
  } catch (e) { /* environnement sans navigator */ }
  return 'fr';
}

// pref : "fr" | "en" | "auto" | null/undefined → langue effective.
export function resoudreLangue(pref) {
  return LANGUES.includes(pref) ? pref : langueAppareil();
}

function lirePreference() {
  try { return localStorage.getItem(CLE_PREFERENCE); } catch (e) { return null; }
}

function appliquer(langue) {
  if (i18n.language !== langue) i18n.changeLanguage(langue);
  try { document.documentElement.lang = langue; } catch (e) { /* SSR/tests */ }
}

// Applique ET mémorise la préférence de l'utilisateur (Mon profil / connexion).
export function appliquerPreferenceLangue(pref) {
  try {
    if (LANGUES.includes(pref)) localStorage.setItem(CLE_PREFERENCE, pref);
    else localStorage.removeItem(CLE_PREFERENCE);
  } catch (e) { /* stockage indisponible : la langue s'applique quand même */ }
  appliquer(resoudreLangue(pref));
}

// Change la langue affichée SANS toucher à la préférence mémorisée
// (ex. bouton FR | EN du formulaire public d'autodéclaration).
export function changerLangueTemporaire(langue) {
  if (LANGUES.includes(langue)) appliquer(langue);
}

// Locale à passer aux toLocaleDateString / Intl (dates au format québécois).
export function localeCourante() {
  return i18n.language === 'en' ? 'en-CA' : 'fr-CA';
}

// Comme localeCourante(), mais garde EXACTEMENT la locale française d'origine
// d'un écran (ex. 'fr-FR' → jj/mm/aaaa) : aucun changement d'affichage en français.
export function localeDates(localeFr = 'fr-CA') {
  return i18n.language === 'en' ? 'en-CA' : localeFr;
}

i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en } },
  lng: resoudreLangue(lirePreference()),
  fallbackLng: 'fr',
  interpolation: { escapeValue: false }, // React échappe déjà
  returnNull: false,
  showSupportNotice: false, // pas de bannière publicitaire dans la console
});

try { document.documentElement.lang = i18n.language; } catch (e) { /* tests */ }

export default i18n;
